// src/components/alertsPhone.js
//
// The phone box on the /alerts form. US and Canada numbers only.
//
// AutoFill can hand the box "+1 916 555 0142", and some people type the leading 1
// themselves. That 1 is the country code, not part of the number. No US or Canadian area
// code starts with 1, so it is always safe to drop, but it has to go BEFORE the number is
// cut into (xxx) xxx-xxxx. This box used to keep the first ten digits with the 1 still on
// the front, so 1-916-555-0142 became (191) 655-5014 and the last digit was gone for good.

/** Every digit of the number, minus any leading country-code 1. Nothing else is ever dropped. */
export const phoneDigits = (value) => String(value ?? '').replace(/\D/g, '').replace(/^1+/, '');

/**
 * What the box shows. Too many digits are shown as typed rather than cut off, so a wrong
 * number can be seen and is refused when the form is sent.
 */
export const formatPhoneNumber = (value) => {
  const digits = phoneDigits(value);
  if (digits.length < 4 || digits.length > 10) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/** Ten digits, and an area code that can exist (none starts with 0 or 1). */
export const isValidPhoneNumber = (value) => /^[2-9]\d{9}$/.test(phoneDigits(value));
